export default "__VITE_ASSET__XRCLpqYI__ 100w";